import CreateSandboxClassPage from './CreateSandboxClass';

export default function EditSandboxClassPage() {
  return <CreateSandboxClassPage />;
}
